import { render, staticRenderFns } from "./SentenceList.vue?vue&type=template&id=7e5aa3ce"
import script from "./SentenceList.vue?vue&type=script&lang=js"
export * from "./SentenceList.vue?vue&type=script&lang=js"
import style0 from "./SentenceList.vue?vue&type=style&index=0&id=7e5aa3ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports